import React from "react";
import { formatISO } from "date-fns";
import queryString from "query-string";
import useSWR from "@/hooks/useSWR";
import useSubscriptionTimestamps from "./useSubscriptionTimestamps";
import { AggregateStatsType } from "../types/AggregateStatsType";
import TimezoneUtils from "../utils/TimezoneUtils";
import useSubuserMode from "./useSubuserMode";
import { toPlanId } from "@/utils/toPlanId";
import { PlanIdTypeSafe } from "@/types/PlanTypes";

export default function useSubscriptionStats(planId: PlanIdTypeSafe) {
  const isSubuserMode = useSubuserMode();
  const { timestampLte, timestampGte } = useSubscriptionTimestamps();

  const [queryStats, setQueryStats] = React.useState<string | undefined>();

  const url = toPlanId(planId)
    ? `/stats/aggregate/?${queryStats}${isSubuserMode ? "" : `&plan_id=${toPlanId(planId)}`}`
    : `/stats/aggregate/?${queryStats}`;

  const { data } = useSWR<AggregateStatsType>({
    enabled: !!queryStats,
    url,
  });

  React.useEffect(() => {
    const qs = queryString.stringify({
      timestamp__lte: timestampLte
        ? formatISO(TimezoneUtils.unzonedDate(timestampLte).setSeconds(0, 0))
        : undefined,
      timestamp__gte: timestampGte
        ? formatISO(TimezoneUtils.unzonedDate(timestampGte).setSeconds(0, 0))
        : undefined,
    });

    if (qs) {
      setQueryStats(qs);
    }
  }, [timestampGte, timestampLte]);

  return data ?? undefined;
}
